
import { styled } from '@mui/material/styles';

export const Container = styled('div')`
    display: flex;
    width: 100%;
    height: 100vh;
`

interface BodyProps {
  $isMobile?: boolean;
}

export const Body = styled('div', { shouldForwardProp: prop => prop !== '$isMobile' })<BodyProps>`
    width: ${props => props.$isMobile ? '100%' : 'calc(100% - 230px)'};
    padding: ${props => props.$isMobile ? '10px 10px 40px 10px' : '0 40px 40px 40px'};
    box-sizing: border-box;
`;

export const Main = styled('div')`
    margin-top: 80px;
`;